<template>
  <div class="flex w-full animate-pulse flex-col">
    <div class="mb-2 h-9 w-3/4 rounded-lg bg-secondary" />
    <div class="h-8 w-40 rounded-lg bg-secondary" />
  </div>
</template>
